var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex font-weight-bold mb-2 px-1" }, [
        _c("div", { staticClass: "flex-fill" }, [
          _vm._v(_vm._s(_vm.__t("UNIQ_ID"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-fill" }, [
          _vm._v(_vm._s(_vm.__t("NAME"))),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { width: "40px" } }),
      ]),
      _vm._v(" "),
      _vm._l(_vm.tables, function (table, index) {
        return _c("div", { key: table.id, staticClass: "d-flex mb-2 px-1" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: table.uniq_id,
                expression: "table.uniq_id",
              },
            ],
            staticClass: "form-control mr-2",
            attrs: { placeholder: _vm.__t("UNIQ_ID_CAN_BE_EMPTY") },
            domProps: { value: table.uniq_id },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(table, "uniq_id", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: table.privat_uniq_id,
                expression: "table.privat_uniq_id",
              },
            ],
            staticClass: "form-control mr-2",
            attrs: { placeholder: _vm.__t("PRIVAT_TABLE") },
            domProps: { value: table.privat_uniq_id },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(table, "privat_uniq_id", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: table.name,
                expression: "table.name",
              },
            ],
            staticClass: "form-control mr-2",
            attrs: { placeholder: _vm.__t("NAME") },
            domProps: { value: table.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(table, "name", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              on: {
                click: function ($event) {
                  return _vm.removeTable(index)
                },
              },
            },
            [_vm._v("x")]
          ),
        ])
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-primary mt-2", on: { click: _vm.addTable } },
        [_vm._v("\n        " + _vm._s(_vm.__t("ADD_TABLE")) + "\n    ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }